import type {
	TokenBatchModel,
	TokenBatchStorePayload,
	TokenBatchUpdatePayload,
} from '@/models/TokenBatch/Model'
import Api from '@/helpers/models/Api'
import type { LaravelPaginationResponse } from '@/interfaces/models/Laravel'

export default class TokenBatchsApi extends Api<
	TokenBatchModel,
	LaravelPaginationResponse<TokenBatchModel>,
	TokenBatchStorePayload,
	TokenBatchUpdatePayload
> {
	route = 'token-batches'

	async update(): Promise<any> {
		throw new Error('Not implemented')
	}

	async updateRelation(): Promise<any> {
		throw new Error('Not implemented')
	}

	async destroy(): Promise<any> {
		throw new Error('Not implemented')
	}

	async store(): Promise<any> {
		throw new Error('Not implemented')
	}
}
